import {Dimensions, Platform} from 'react-native'
import { JDJumping } from '@jdreact/jdreact-core-lib'
import { JDDevice } from '@jdreact/jdreact-core-lib'
import defaultImg from '../images/img_default.png'

const {height} = Dimensions.get('window')
import { isQQ, isWX, isJDApp } from '../components/utiles';

// 获取数据类型类型
function getType(info) {
  const type = Object.prototype.toString.call(info)
  return type.substr(8, type.length - 9).toLowerCase()
}

/**
 * 根据传入不同平台获取传入数据数值。
 * 解决问题：web端样式使用小数会被省略编译。例如
 *  lineHeight: 1 ==> 编译后：lineHeight: 1px
 * 避免这样编译。将数字1改为字符串1
 */
function getNumberOfPlatform(number) {
  switch(Platform.OS) {
    case 'web':
      return number.toString()
    default:
      return number
  }
}

/**
 * imgProcess
 * @param url 路径，必传
 * @param nx 业务域名，非必传，默认"esf"支持gif动图，补白图为方形，为'da','n0','n1','n2','n3','n4'
 * @param size 尺寸,非必传，默认"800x800",屏幕1/2宽度可以400x400"，1/3可以是"300x300"
 * @param q 降质程度，非必传，默认70
 * @param index 从公网访问图片使用的域名指引，非必传，默认是第一个，即img10.360buyimg.com
 * @param wh 按照一定的宽高比例居中裁剪图片，非必传，传入形式'!cc_2x1','!cc_5x3', 宽高比
 * @returns {*}
 */
function imgProcess(url, size="800x800", q=70, index=0, nx="esf", wh=""){
	var ext = "";
	let domainArr = [10, 11, 12, 13, 14, 20, 30]; // 从公网访问图片使用的域名数组
	let randomDomain = domainArr[index]; // 获取图片使用的域名
	if (/\/jfs\//.test(url)) { // 全路径的时候
		if (/\.gif$/.test(url)) {
			return 'https://img'+randomDomain+'.360buyimg.com/esf/'+url.split("/jfs/")[1]+wh;
		} else {
			return 'https://img'+randomDomain+'.360buyimg.com/'+nx+'/s'+size+'_jfs/'+url.split("/jfs/")[1]+'!q'+q+wh+ext;
		}
	} else if (/^jfs\//.test(url)) { // jfs开头的路径的时候
		if (/\.gif$/.test(url)) {
			return 'https://img'+randomDomain+'.360buyimg.com/esf/'+url+wh;
		} else {
			return 'https://img'+randomDomain+'.360buyimg.com/'+nx+'/s'+size+'_'+url+'!q'+q+wh+ext;
		}
	} else { // 不做处理
		return url;
	}
}

function isPhoneX() { // 判断是否是iphoneX以上的机型
	if (Platform.OS === 'ios') {
		if (height >= 812) {
			return true;
		}
	} else if (Platform.OS === "web") {
		let ua = (navigator && navigator.userAgent) || ''
		let u = ua, app = navigator.appVersion;
		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		if (isIOS && window.screen.height >= 812) { // 在web端不能直接用rn的方法获取的高度height，获取的高度是不准确的
			return true;
		}
	}
	return false;
}
export const isWeb = Platform.OS === 'web';

function pt (num) { 
	return JDDevice.getRpx(num)
}

/**
 * 判断是否是京东app的webview
 */
function isJDAppWebView() {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const ua = window.navigator.userAgent.toLowerCase();
    const isJdApp = ua.indexOf('jdapp') > -1;
    if (isJdApp ) {
      return true;
    }
  }
  return false;
}

// 给个位数字前面添加0
const addZero = (num) => {
  if (num < 10) {
    return `0${num}`
  }
  return num
}
/**
 * 将时间戳格式化为xx-xx-xx xx:xx:xx,
 * @param time 时间戳
 * @param isSimple true的时候只展示年月日，false的时候展示时分秒年月日
 * @param dateSplit 日期的分隔符，默认以'.'分隔，可以传入'-'、'CHS'，传入'CHS'表示返回年月日的样式
 * @returns {string}
 */
//
// isSimple：true的时候只展示年月日，false的时候展示时分秒年月日
const formatTimeStamp = (
  time,
  isSimple = false,
  dateSplit = '.'
) => {
  let strTime = ''
  if (time && Number(time)) {
    const createDate = new Date(Number(time))
    if (dateSplit === 'CHS') {
      strTime += `${addZero(createDate.getFullYear())}年`
      strTime += `${addZero(createDate.getMonth() + 1)}月`
      strTime += `${addZero((createDate.getDate()))}日`
    } else {
      strTime += `${addZero(createDate.getFullYear())}${dateSplit}`
      strTime += `${addZero(createDate.getMonth() + 1)}${dateSplit}`
      strTime += addZero((createDate.getDate()))
    }

    if (!isSimple) {
      strTime += ` ${addZero(createDate.getHours())}:`
      strTime += `${addZero(createDate.getMinutes())}:`
      strTime += addZero(createDate.getSeconds())
    }
  }
  return strTime
}

/**
 * 格式化跳转链接
 * @param {*} url
 */
const formatJumpUrl = (url) => {
  let jumpUrl = url;
  if (url && url.length) {
      if (url.startsWith('//')) {
          jumpUrl = `https:${jumpUrl}`;
      }
      if (url.startsWith('http://')) {
          jumpUrl = url.replace('http://', 'https://');
      }
      return jumpUrl;
  }
  return '';
}

const jumpUrl = (jumpUrl, isNewWebView = true) => {
  const formattedJumpUrl = formatJumpUrl(jumpUrl);
  if (formattedJumpUrl && formattedJumpUrl.length) {
    if (Platform.OS === 'web' && isJDAppWebView() && isNewWebView) {
      // 在京东app中的h5，使用协议新开webview
        JDJumping.jumpToOpenapp(`openApp.jdMobile://virtual?params={"category":"jump","des":"m","action":"to","url":"${encodeURIComponent(formattedJumpUrl)}"}`);
    } else {
      // 加点延时，否则事件埋点请求会被取消
      setTimeout(() => {
        JDJumping.jumpToWeb(formattedJumpUrl);
      }, 100);
    }
  }
}
/**
 * 底部吸底图片路径校验
 * 只接收 jfs 路径的图片
 * @param {*} url
 */
const formatImgUrl = (url) => {
  if (url && /^jfs\//.test(url)){
    return 'https://m.360buyimg.com/mobilecms/'+ url
  }else {
    return defaultImg
  }
}

// const jumpingToShop = (shopId,venderId) => {
//   if (Platform.OS === 'web' && isJDAppWebView()) {
//    JDJumping.jumpToOpenapp(`openApp.jdMobile://virtual?params={"category":"jump","des":"jshopMain","shopId":${shopId},"venderId":${venderId}}`);
//   } else {
//   }
// }

const toDongDong = (obj) => {
  var paramsdata = {
    skuId: obj.skuId,
    name: obj.name || "商品名称",
    imgUrl: obj.imgUrl || 'https://static.360buyimg.com/fang/xinfang/static/img/sharelogo.png',
    price: obj.price || "0",
    venderId: obj.venderId || ''
  }
  obj.content && (paramsdata.content = obj.content);
  let URL = ''
  if (Platform.OS === 'web') {
    if (isJDApp && !isHarmonyWeb()) {
      const webparams = {
        category: 'jump',
        des: 'im',
        skuId: String(paramsdata.skuId),
        name: paramsdata.name,
        imgUrl: `https://img10.360buyimg.com/mobilecms/s160x160_${paramsdata.imgUrl}`,
        price: paramsdata.price,
      }; 
      URL = `openApp.jdMobile://virtual?params=${JSON.stringify(webparams)}`;
      JDJumping.jumpToOpenapp(URL)
      // JDJumping.jumpToWeb('router://JDDongdongModule/openVenderService?venderId=' + paramsdata.venderId)
    } else { //m页 entry必传
      URL = 'https://chat.jd.com/chat/index?venderId='+paramsdata.venderId + '&sku=' + paramsdata.skuId + '&imgUrl=' + paramsdata.imgUrl + '&goodName=' + paramsdata.name + '&jdPrice=' + paramsdata.price + '&sid=0&entry=m_item'
      JDJumping.jumpToWeb(URL)
    }
  } else { 
    JDJumping.jumpToIM(paramsdata.venderId)
  }
}


const jumpingToWeb = (url) => {
  if (Platform.OS === 'web' && isJDAppWebView()) {
   // 在京东app中的h5，使用协议新开webview
   JDJumping.jumpToOpenapp(`openApp.jdMobile://virtual?params={"category":"jump","des":"m","action":"to","url":"${encodeURIComponent(url)}"}`);
  } else {
   JDJumping.jumpToWeb(url)
  }
}

const isHarmonyWeb = () => {
  if (Platform.OS === 'web') {
    if (typeof jmfe !== 'undefined') {
      return jmfe.isHarmony()
    } else {
      return false
    }
  } else {
    return false
  }
}

const harmonyWebShare = (objShare) => {
  if (Platform.OS === 'web' && isJDAppWebView()) {
    if (typeof jmfe !== 'undefined') {
      jmfe.setShareInfo({
        title: objShare.title,
        content: objShare.content,
        url: objShare.url,
        channel: "Wxfriends,Wxmoments,CopyURL,QQfriends,QQzone",
        img: objShare.shareImg
      })
    } 
  }
}

export {
  getType,
  getNumberOfPlatform,
	imgProcess,
	isPhoneX,
	pt,
	isJDAppWebView,
	formatTimeStamp,
  formatJumpUrl,
  jumpUrl,
  formatImgUrl,
  jumpingToWeb,
  toDongDong,
  isHarmonyWeb,
  harmonyWebShare
}
